export default "__VITE_ASSET__BDRK0JgI__"